// extracted by mini-css-extract-plugin
export default {"noTrips":"xRuVDD","background":"CeHxw3","content":"Xyi3kA","heading":"To1TYp","description":"b9emVd","refresh":"fb0VeO","bookWithoutPNR":"vqdfKf","button":"uOxcAx","icon":"Fp73_2"};